import React from 'react';
import AdminPanel from '../components/Admin/AdminPanel';
import { ErrorBoundary } from '../components/ErrorBoundary';
import { ToastProvider, ToastContainer } from '../components/Toast';
import PerformanceWrapper from '../components/PerformanceWrapper';

const AdminPage: React.FC = () => {
  return (
    <ErrorBoundary>
      <PerformanceWrapper enableMonitoring={true} performanceThreshold={25}>
        <ToastProvider maxToasts={5}>
          <AdminPanel />
          <ToastContainer position="top-right" />
        </ToastProvider>
      </PerformanceWrapper>
    </ErrorBoundary>
  );
};

export default AdminPage;